/**
 * Asynchronous support for page view counting.
 */
import 'whatwg-fetch';
import EmCookie from './em-cookie';

const pageViewCounter = async () => {
	const emClient = window.EmClient;
	if (emClient === undefined) return false;
	if (!emClient.onPostPage) return false;
	if (emClient.currentPostType !== 'post') return false;

	const config = {
		postId: emClient.currentPostId,
		nonce: emClient.nonce,
		api: `${emClient.restUrl}em-client/v1/post-view`,
		cookieName: 'emPageView',
		cookieExpiration: 30,
	};

	const emCookie = new EmCookie(config.cookieName);
	const emCookieCheck = emCookie.access();

	if (!emCookieCheck) {
		/**
		 * Create Cookie since it doesn't exist yet.
		 */
		emCookie.create(true, config.cookieExpiration);

		/**
		 * Add post count to api endpoint.
		 */
		try {
			const response = await fetch(config.api, {
				method: 'POST',
				body: JSON.stringify({
					post_id: config.postId,
				}),
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': config.nonce,
				},
			});
			const json = await response.json();
			return json.message;
		} catch (error) {
			console.error('Error: ', error);
			return false;
		}
	}
	return true;
};

export default pageViewCounter;
